import { render } from "./FormForgotPswd.vue?vue&type=template&id=95cc6108&scoped=true"
import script from "./FormForgotPswd.vue?vue&type=script&lang=js"
export * from "./FormForgotPswd.vue?vue&type=script&lang=js"

import "./FormForgotPswd.vue?vue&type=style&index=0&id=95cc6108&scoped=true&lang=css"

import exportComponent from "D:\\Development\\javascript\\accounts-butago-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95cc6108"]])

export default __exports__